export const products = [
  {
    id: 'p1',
    name: 'ForgeGun Pro v2',
    tagline: 'Deep Tissue Percussion',
    price: 249,
    image: 'https://images.unsplash.com/photo-1633526543814-9718c8922b7a?auto=format&fit=crop&q=80&w=800',
    category: 'upper-body',
    rating: 4.9,
    reviews: 1240
  },
  {
    id: 'p2',
    name: 'PulseBoots Aero',
    tagline: 'Dynamic Compression',
    price: 699,
    image: 'https://images.unsplash.com/photo-1584735935682-2f2b69dff9d2?auto=format&fit=crop&q=80&w=800',
    category: 'leg-day',
    rating: 4.8,
    reviews: 892
  },
  {
    id: 'p3',
    name: 'ThermalWrap Node',
    tagline: 'Contrast Therapy Wrap',
    price: 129,
    image: 'https://images.unsplash.com/photo-1574680096145-d05b474e2155?auto=format&fit=crop&q=80&w=800',
    category: 'rest-day',
    rating: 4.7,
    reviews: 450
  },
  {
    id: 'p4',
    name: 'AeroSphere',
    tagline: 'Vibrating Mobility Core',
    price: 89,
    image: 'https://images.unsplash.com/photo-1600881333168-2ef49b341f30?auto=format&fit=crop&q=80&w=800',
    category: 'active-recovery',
    rating: 4.9,
    reviews: 312
  }
];

export const bundles = [
  {
    id: 'b1',
    name: 'The Ironclad Protocol',
    includes: ['PulseBoots Aero', 'ForgeGun Pro v2'],
    price: 850,
    originalPrice: 948,
    image: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&q=80&w=800'
  },
  {
    id: 'b2',
    name: 'Weekend Warrior Kit',
    includes: ['ForgeGun Pro v2', 'AeroSphere'],
    price: 299,
    originalPrice: 338,
    image: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?auto=format&fit=crop&q=80&w=800'
  }
];

export const stages = [
  { step: '01', title: 'Activate', desc: 'Pre-workout stimulation to awaken muscle groups and increase local circulation.', icon: 'Zap' },
  { step: '02', title: 'Perform', desc: 'Maintain mobility and flush tension between sets or during active intervals.', icon: 'Activity' },
  { step: '03', title: 'Flush', desc: 'Immediate post-training compression to support the body\'s natural cool-down process.', icon: 'RefreshCw' },
  { step: '04', title: 'Restore', desc: 'Deep tissue work on rest days to maintain readiness for the next session.', icon: 'Shield' }
];

export const faqs = [
  { q: "Is this a medical device?", a: "No. PulseForge products are designed for fitness and sports recovery. They support natural mobility and readiness, but are not intended to diagnose, treat, or cure any medical condition." },
  { q: "What is your return policy?", a: "We offer a 30-day performance guarantee. If you don't feel the difference in your routine, return it in original condition for a full refund." },
  { q: "How long does shipping take?", a: "Standard lab processing takes 1-2 days. Expedited shipping delivers in 2-3 business days nationwide." }
];